// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__25Vge","left":"InfoRow_left__1lr-7"};